{
  "payment": {
    "paymentCard": {
      "brand": {
        "DS": "Discover"
      }
    }
  }
}
